import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';

@Injectable({
    providedIn: 'root',
})
export class GoogleAddressService {
    constructor(private http: HttpClient) {}

    private apiKey = 'AIzaSyC2ca41vx_8qgTH2j5s3oDfoNRYyfpLi2A';

    private extractData(res: Response) {
        const body: Response = res;
        return body || {};
    }

    geocoding(lat: number, lon: number) {
        return this.http
            .get(
                `https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${lon}&key=${this.apiKey}`
            )
            .pipe(map(this.extractData));
    }

    reverse(adresse: string) {
      
        adresse= encodeURI(adresse);
        return this.http
            .get(
                `https://maps.googleapis.com/maps/api/geocode/json?address=${adresse}&key=${this.apiKey}`
            )
            .pipe(map(this.extractData));
    }

    // autoComplete() {
    //     return this.http.get(
    //         `https://maps.googleapis.com/maps/api/js?key=${this.apiKey}&libraries=places&callback=initMap`
    //     );
    // }
}
